import React from "react"
import { useLocation } from "react-router-dom"

import { useAuth } from "@/features/auth/context/AuthContext"
import { useAppTheme } from "@/shared/context/ThemeContext"
import LogoutConfirmDialog from "@/shared/components/LogoutConfirmDialog"
import PasswordResetConfirmDialog from "@/shared/components/PasswordResetConfirmDialog"
import useAppBarState from "@/shared/components/appbar/hooks/useAppBarState"
import MobileTopBar from "@/shared/components/appbar/MobileTopBar"
import NavDrawer from "@/shared/components/appbar/NavDrawer"
import DrawerContent from "@/shared/components/appbar/DrawerContent"

const AuthenticatedAppBar: React.FC = () => {
  const { user } = useAuth()
  const { mode, toggleTheme } = useAppTheme()
  const location = useLocation()
  const {
    mobileOpen,
    handleDrawerClose,
    handleDrawerTransitionEnd,
    handleDrawerToggle,
    logoutConfirmOpen,
    closeLogoutConfirm,
    confirmLogout,
    onLogout,
    passwordResetConfirmOpen,
    closePasswordResetConfirm,
    confirmPasswordReset,
    handlePasswordReset
  } = useAppBarState()

  return (
    <>
      <MobileTopBar onToggleDrawer={handleDrawerToggle} />
      <NavDrawer mobileOpen={mobileOpen} onClose={handleDrawerClose} onTransitionEnd={handleDrawerTransitionEnd}>
        <DrawerContent
          currentPath={location.pathname}
          onNavigate={handleDrawerClose}
          mode={mode}
          toggleTheme={toggleTheme}
          user={user}
          onPasswordReset={handlePasswordReset}
          onLogout={onLogout}
        />
      </NavDrawer>
      <PasswordResetConfirmDialog
        open={passwordResetConfirmOpen}
        email={user?.email}
        onClose={closePasswordResetConfirm}
        onConfirm={confirmPasswordReset}
      />
      <LogoutConfirmDialog open={logoutConfirmOpen} onClose={closeLogoutConfirm} onConfirm={confirmLogout} />
    </>
  )
}

export default AuthenticatedAppBar
